import { Component, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import {Debounce} from 'lodash-decorators/debounce';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService, NotificationService, ProfileService } from '@patientlynk3/services';
import { RelativeTimePipeModule } from '@patientlynk3/pipes/relative-time.pipe';
import { SvgIconComponentModule } from '@patientlynk3/components/svg-icon/svg-icon.component';
import { DependentColorDirectiveModule } from '@patientlynk3/directives/dependent-color.directive';
import { ActivityGroup } from '@patientlynk3/models';
import { theme } from '@theme/.';
import { PatientlynkOutroModalComponent } from '@patientlynk3/components/patientlynk-outro-modal/patientlynk-outro-modal.component';
import { filter, map } from 'rxjs/operators';
import { SettingsService } from '@patientlynk3/services/settings';
import { environment as env } from '@patientlynk3/environment';

@Component({
  selector: 'app-notification-pane',
  templateUrl: './notification-pane.component.html',
  styleUrls: ['./notification-pane.component.scss']
})
export class NotificationPaneComponent {
  lang$ = this.t.langChanges$;

  constructor(private router: Router,
              private profileService: ProfileService,
              public notifService: NotificationService,
              private settings: SettingsService,
              private auth: AuthService,
              private modal: NgbModal,
              private t: TranslocoService) {
  }

  trackNotification(index, item) {
    return item.id && item.is_read;
  }

  @Debounce(100)
  @HostListener('scroll', ['$event.target'])
  onLoadMore(target) {
    const scrollOffset = target.offsetHeight + target.scrollTop;
    const threshold = target.scrollHeight * 0.7;
    if (scrollOffset >= threshold) {
      this.notifService.onGetNextNotifications();
    }
  }

  getPersonById(personId: string) {
    return this.profileService.get$.pipe(
      filter(profile => !!profile.id),
      map(profile => {
        const { first_name, last_name, dependents } = profile;
        const dependent = dependents?.find(dep => dep.id === personId);

        return dependent || { first_name, last_name };
      }),
    );
  }

  isExternal(source: string[]) {
    if (!theme.whitelabel || !source || !source.length) {
      return false;
    } else {
      return source
        .filter(name => name !== theme.name.toLowerCase())
        .length;
    }
  }

  handleClick(notification: ActivityGroup, event: MouseEvent) {
    
    // Use `production` name specifically because demo environment is set to `production: true`
    if (env.name !== 'production' && event.metaKey) {
      this.notifService.deleteActivity(notification);
      return;
    }

    const { translate, link, source } = notification;
    console.log(notification);
    

    if (translate === 'providerFileReceived') {
      this.router.navigateByUrl('/health_records');
    } else if (translate === 'newLabReceived' && link) {
      const isExternal = this.isExternal(source);
      const { patientLynkOutroPopup } = this.settings.getValue();

      if (isExternal && patientLynkOutroPopup.dontShow) {
        const refresh = this.auth.store.getValue().refresh;
        const encodedLink = encodeURIComponent(link);

        document.location.href =
          env.patientlynk_url + `/login?token=${refresh}&url=${encodedLink}`;
      } else if (isExternal) {
        this.modal.open(PatientlynkOutroModalComponent, {
          size: 'lg',
          centered: true,
          animation: true,
        });
      } else {
        console.log(link);
        
        this.router.navigate([link]);
      }
    }
  }

  onRetry() {
    this.notifService.retried = true;
    this.notifService.load();
  }
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    RelativeTimePipeModule,
    SvgIconComponentModule,
    DependentColorDirectiveModule
  ],
  declarations: [NotificationPaneComponent],
  exports: [NotificationPaneComponent]
})
export class NotificationPaneComponentModule {}
